module.exports = __webpack_public_path__ + "static/media/clapton 2.1.fa60e96b.jpg";